import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

const MenuCPA: React.FC = () => {
  return (
    <Button
      component={Link}
      to="/cpa/sobre"
      sx={{fontSize: '16px',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 500,
        px: 2,
        py: 1,
        '&:hover': {
          backgroundColor: '#fca138',
        },
      }}
    >
      CPA
    </Button>
  );
};

export default MenuCPA;
